export const WALLET_TOP_UP = 'WALLET_TOP_UP';
export const WALLET_TOP_UP_SUCCESS = 'WALLET_TOP_UP_SUCCESS';
export const WALLET_TOP_UP_ERROR = 'WALLET_TOP_UP_ERROR';

export const ADMIN_PAYMENT = 'ADMIN_PAYMENT';
export const ADMIN_PAYMENT_SUCCESS = 'ADMIN_PAYMENT_SUCCESS';
export const ADMIN_PAYMENT_ERROR = 'ADMIN_PAYMENT_ERROR';

export const CONFIRM_PAYMENT = 'CONFIRM_PAYMENT';
export const CONFIRM_PAYMENT_SUCCESS = 'CONFIRM_PAYMENT_SUCCESS';
export const CONFIRM_PAYMENT_ERROR = 'CONFIRM_PAYMENT_ERROR';

export const ADPAY_FAILED = 'ADPAY_FAILED';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';

export const FETCH_FEES = 'FETCH_FEES';
export const FETCH_FEES_SUCCESS = 'FETCH_FEES_SUCCESS';
export const FETCH_FEES_ERROR = 'FETCH_FEES_ERROR';

export const MAKE_PAYMENT = 'MAKE_PAYMENT';
export const MAKE_PAYMENT_SUCCESS = 'MAKE_PAYMENT_SUCCESS';
export const MAKE_PAYMENT_ERROR = 'MAKE_PAYMENT_ERROR';

export const CONFIRM_PAYMENT_SERVICE = 'CONFIRM_PAYMENT_SERVICE';
export const CONFIRM_PAYMENT_SERVICE_SUCCESS = 'CONFIRM_PAYMENT_SERVICE_SUCCESS';
export const CONFIRM_PAYMENT_SERVICE_ERROR = 'CONFIRM_PAYMENT_SERVICE_ERROR';

export const RESET_PAYMENT_REDUCER = 'RESET_PAYMENT_REDUCER';

export const FETCH_PAYMENT_BREAKDOWN = 'FETCH_PAYMENT_BREAKDOWN';
export const FETCH_PAYMENT_BREAKDOWN_SUCCESS = 'FETCH_PAYMENT_BREAKDOWN_SUCCESS';
export const FETCH_PAYMENT_BREAKDOWN_ERROR = 'FETCH_PAYMENT_BREAKDOWN_ERROR';

export const ADMIN_FETCH_PAYMENT_BREAKDOWN_SUCCESS = 'ADMIN_FETCH_PAYMENT_BREAKDOWN_SUCCESS';
export const RESET_BREAKDOWN_SUCCESS = 'RESET_BREAKDOWN_SUCCESS';

export const RESET_MAKE_PAYMENT_ERROR = 'RESET_MAKE_PAYMENT_ERROR';
